export default "__VITE_ASSET__dc61c528__"